/**
 * Chat can spend when the writer has a key or a balance the settings
 * payload already reports. has_api_key alone hid the composer band for
 * a balance that was nested, or present without that flag (#1223).
 */
export function unwrapSettings(response) {
  let current = response;
  for (let depth = 0; depth < 3; depth += 1) {
    if (!current || typeof current !== 'object') return {};
    if (
      Object.prototype.hasOwnProperty.call(current, 'has_api_key')
      || Object.prototype.hasOwnProperty.call(current, 'credits_remaining')
      || Object.prototype.hasOwnProperty.call(current, 'model_preferences')
    ) {
      return current;
    }
    current = current.data;
  }
  return {};
}

export function chatSpendPossible(settings) {
  if (!settings) return false;
  if (settings.has_api_key || settings.api_key_valid) return true;
  return typeof settings.credits_remaining === 'number';
}
